// utils/fileTypes.js
export const imgExt = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
export const pdfExt = ["pdf"];
export const videoExt = ["mp4", "mov", "webm", "mkv", "avi"];
export const audioExt = ["mp3", "wav", "flac", "m4a"];
export const archiveExt = ["zip", "rar", "7z", "tar", "gz"];
export const validExtensions = [...imgExt, ...pdfExt, ...videoExt];

export const extOf = (f) => f.toLowerCase().split(".").pop();

export function getFileIcon(name) {
  const ext = extOf(name);
  if (imgExt.includes(ext)) return "🖼️";
  if (videoExt.includes(ext)) return "🎬";
  if (pdfExt.includes(ext)) return "📄";
  if (audioExt.includes(ext)) return "🎵";
  if (archiveExt.includes(ext)) return "🗜️";
  return "📁";
}
